import { useEffect, useRef } from "react";
import nextCookie from "next-cookies";
import Router from "next/router";
import Head from "next/head";
import { Line, Logo, Bottom } from "../../styles/styles-marcas/gallery"
import InputMask from 'react-input-mask';
import Layout from "../../components/Layout";
import Container from "../../components/Container";
import { ProductList } from "../../components/ProductList/styles";
import { Pagination } from "../../components/Pagination/styles";
import { productsApi } from "../../services/api";
import { ProductArea } from "../../styles/styles-marcas/ProductArea";
import ProductListComponent from "../../components/ProductList";
import PaginationComponent from "../../components/Pagination";
 

const Gallery = ({ products, pages, token, cart_token }) => {

  return (
    <Layout>
      <Head>
        <title key="title">Goods Br | Gallery</title>
        <meta key="og-title" property="og:title" content="Login | Goods Br" />
      </Head>
        <Container>
          <Logo src="/lg_goods-gallery.png" alt="Logo Goods Br Gallery" style={{marginLeft: "25%", marginRight: "25%"}}/>
          <Line>
          <Bottom>
            <h2>Nossa ideia não é só vender quadros, mas representar artistas de vários lugares do mundo, como Nova York, Alemanha, Ucrânia e trabalhar isso de forma exclusiva no Brasil.</h2>
          </Bottom>
          </Line>
        </Container>
        <ProductArea token={token}>
          <ProductListComponent title="PN" products={products} cart_token={cart_token} >
            <PaginationComponent pages={pages} baseHref={`/gallery`} />
          </ProductListComponent>
        </ProductArea>
    </Layout>
  );
};

Gallery.getInitialProps = async ctx => {
  const { token } = nextCookie(ctx);
  const { page } = ctx.query;

  const { products, pages } = await productsApi.gallery({
    user_token: token,
    page
  });

  return {
    products,
    pages,
    token
  };
};

export default Gallery;
